const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{mID} .gf_collection-banner-title #{titleTag}',
};
export default {
  defaultClass: 'gf_gs-text-heading-2',
  settingGroups: {
    [globalStyleId]: {
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'line-height': {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      'letter-spacing': {
        ...defaultSelector,
        inherit: 'text.letterSpacing',
        cssAttr: 'letter-spacing',
        listUnit: 'px',
      },
      // "text-color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      'font-style': {
        ...defaultSelector,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
      'font-style-weight': {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-style-decoration': {
        ...defaultSelector,
        inherit: 'text.decoration',
        cssAttr: 'text-decoration',
      },
    },
  },
};

export const COLLECTION_TITLE_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    titleTag: 'h1,h2,h3,h4,h5,h6,p',
    typeSetting: 'heading',
  },
];
